import { useConfigStore } from "../../Stores/Config";
import { useTicketStore } from "../../Stores/Ticket";
import WidgetChatComposer from "../WidgetChatComposer/WidgetChatComposer";
import WidgetContentList from "../WidgetContentList/WidgetContentList";
import WidgetMenuTag from "../WidgetMenuTag/WidgetMenuTag";
import "./WidgetMenu.scss";

const WidgetMenu = () => {
  const configStore = useConfigStore();

  const renderAIChatbar = () => {
    const isV3 = configStore.getHomeVersion() === 3;
    if (!isV3) {
      return null;
    }

    return (
      <div className="widget-ai-chatbar" key="aichatbar">
        <div className="widget-ai-chatbar-body">
          <WidgetChatComposer
            sendMessage={(message, opts) => {
              useTicketStore.getState().createNewConversation(
                {
                  aiQuestion: true,
                  navDelayMs: opts.navDelayMs,
                  firstMessageAttachments: opts.attachments,
                },
                message,
              );
            }}
          />
        </div>
        <div className="widget-ai-chatbar-tags">
          {configStore.homeWidgets.map((widget, index) => {
            if (widget.type === "menu") {
              return (
                <WidgetMenuTag
                  menuItem={widget.config}
                  index={index}
                  key={index}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="widget-menu">
      {renderAIChatbar()}
      <WidgetContentList />
    </div>
  );
};

export default WidgetMenu;
